import { P2GBox } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';

import IncExc from './IncExc';
import { FilterOptionsGridProps } from './FilterOptionsGrid';
import { P2GGrid } from '@parcel2go/core-ui';
import P2GConditionalImage from '../../P2GConditionalImage';
import IndexFade from './IndexFade';

const FilterOptionsGridImage = (props: FilterOptionsGridProps) => (
  <IncExc
    mode={props.mode}
    setMode={props.setMode}
    ctr={
      <P2GLinkGroup
        links={[
          props.selected.length > 0 && (
            <P2GLink variant="body2" onClick={props.clearSelected}>
              Clear
            </P2GLink>
          ),
          props.selected.length < props.filterItem.options.length && (
            <P2GLink variant="body2" onClick={props.selectAll}>
              Select All
            </P2GLink>
          )
        ]}
      />
    }
  >
    <P2GBox>
      <P2GGrid container spacing={1}>
        {props.filterItem.options.map((a, i) => (
          <P2GGrid item key={a.value} xs={6} sm={4}>
            <IndexFade index={i}>
              <div title={a.text}>
                <P2GBox bordered pl={1} pr={1} textAlign="center">
                  <P2GCheckBoxLegacy
                    id={a.value}
                    checked={props.isSelected(a.value)}
                    onChange={() => props.toggleSelected(a.value)}
                    label={
                      <P2GConditionalImage style={{ height: '50px', maxWidth: '100%' }} alt={a.text} src={a.image} />
                    }
                    labelPlacement="end"
                    variant="primary"
                    error={false}
                  />
                </P2GBox>
              </div>
            </IndexFade>
          </P2GGrid>
        ))}
      </P2GGrid>
    </P2GBox>
  </IncExc>
);

export default FilterOptionsGridImage;
